import { useMutation, useQueryClient } from '@tanstack/react-query';
import { archiveSite } from '../api/sitesApi';
import { sitesKeys } from './useSites';

/**
 * Mutation hook for archiving a site.
 *
 * Errors are handled by the global QueryClient onError (shows snackbar).
 * Callers can override with mutate(undefined, { onSuccess, onError }).
 */
export const useArchiveSite = (siteId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => archiveSite(siteId),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: sitesKeys.lists(),
      });
      queryClient.invalidateQueries({
        queryKey: sitesKeys.detail(siteId),
      });
    },
  });
};
